export enum ConsultantLeadStatus {
  NotContacted = "NotContacted",
  ContactedNoAnswer = "ContactedNoAnswer",
  Assigned = "Assigned",
  BadTiming = "BadTiming",
  NotRelevant = "NotRelevant",
  RelevantLater = "RelevantLater",
  Warm = "Warm",
  // happens when someone resets responsible person for a consultant with lead status == "Assigned"
  Unknown = "Unknown"
}

export const manualLeadStatuses = [
  ConsultantLeadStatus.BadTiming,
  ConsultantLeadStatus.NotRelevant,
  ConsultantLeadStatus.RelevantLater,
  ConsultantLeadStatus.Warm,
  ConsultantLeadStatus.Unknown
];
